module.exports = __webpack_public_path__ + "img/save_invoice.5d494c80.svg";